import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
import config from "../../config/config";
import Delete from "material-ui/svg-icons/action/delete";
import { Table, TableBody, TableRow, TableRowColumn } from "material-ui";
import { tdStyle } from "../Questionnaire/QuestionnaireTable";
import AvPlayCircleFilled from "material-ui/svg-icons/av/play-circle-filled";
import ActionGetApp from "material-ui/svg-icons/action/get-app";
import EditorInsertDriveFile from "material-ui/svg-icons/editor/insert-drive-file";
import S3 from "aws-sdk/clients/s3";
import { convertToCsv } from "../../routes/Transcriptions/convertToCsv";
import { CSVLink } from "react-csv";
import { checkMobile, isIpadOS } from "../../lib";
import PlayAndDownloadDialog from "./PlayAndDownloadDialog";
import { TableHeader } from "material-ui/Table";

const iconStyle = {
  width: "25px",
  height: "25px",
  color: "#6b7c93",
  cursor: "pointer",
};

class RoomRecordingsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      csvData: [],
      csvFileName: "",
      showDialog: false,
      selectedRecording: null,
      type: null
    };
  }
  checkMessageFormat(messageId) {
    const { intl } = this.props;
    return intl.formatMessage({ id: messageId });
  }

  durationFormat = (end, start) => {
    const { intl } = this.props;
    end = moment.unix(end).format("YYYY-MM-DD HH:mm:ss");
    start = moment.unix(start).format("YYYY-MM-DD HH:mm:ss");
    let res = moment.duration(moment(end).diff(moment(start)));
    let format =
      "HH[" +
      this.checkMessageFormat("roomRecordings.hours") +
      "]mm[" +
      this.checkMessageFormat("roomRecordings.minutes") +
      "]ss[" +
      this.checkMessageFormat("roomRecordings.seconds") +
      "]";
    return moment.utc(res.asMilliseconds()).format(format);
  };

  handleDelete = (e, id) => {
    if (
      window.confirm(this.checkMessageFormat("roomRecordings.confirmation"))
    ) {
      this.props.handleDeleteTouch(
        e,
        <div>
          <FormattedMessage id="seminarActions.singleRemoved" />
        </div>,
        id
      );
    }
  };

  viewTranscriptions(transcription) {
    this.props.history.push({
      pathname: "/admin/transcription-info",
      state: { transcription, searchText: "" },
    });
  }

  downloadTranscription = (recording) => {
    if (recording) {
      const googleTranscription = JSON.parse(recording.google_stt);
      if (googleTranscription.length > 0) {
        const csvData = convertToCsv(recording, googleTranscription);
        const date = moment.unix(recording.recording_started_at);
        const csvFileName = `${
          recording.channel_id.split(".")[1]
        }_${date.format("YYYYMMDDHHmm")}`;
        this.setState({ csvData, csvFileName }, () => {
          if (this.csvLinkRef && this.csvLinkRef.link) {
            this.csvLinkRef.link.click();

            setTimeout(() => {
              this.setState({ csvData: [], csvFileName: "" });
            }, 3000);
          }
        });
      }
    }
  };

  downloadVideo = async (url) => {
    const S3Client = new S3(config.S3);
    const Key = url.split("/")[url.split("/").length - 1];
    let params = {
      Bucket: config.S3.bucketName,
      Key: decodeURIComponent(Key),
      Expires: 3000,
      ResponseContentDisposition: `attachment; filename="${decodeURIComponent(
        Key
      )}"`,
    };
    const result = await S3Client.getSignedUrlPromise("getObject", params).catch((e) => {
      console.log(e);
    });
    var a = document.createElement("a");
    a.href = result;
    a.download = "LFV.ADMIN";
    document.body.appendChild(a);
    a.click();
    setTimeout((_) => {
      window.URL.revokeObjectURL(url);
    }, 60000);
    a.remove();
  };

  // handlePlay = (recording) => {
  //   this.setState({ selectedRecording: recording, type: 'play' }, () => {
  //     this.setState({ showDialog: true });
  //   });
  // }

  // handleDownload = (recording) => {
  //   this.setState({ selectedRecording: recording, type: 'download' }, () => {
  //     this.setState({ showDialog: true });
  //   });
  // }


  render() {
    const { intl } = this.props;
    return (
      <div>
        <CSVLink
          ref={(r) => (this.csvLinkRef = r)}
          data={this.state.csvData}
          filename={this.state.csvFileName}
        ></CSVLink>
        {/* {this.state.showDialog &&
        <PlayAndDownloadDialog
          open = {this.state.showDialog}
          handleClose = {() => {
            this.setState({ showDialog: false, selectedRecording: null, type: null })
          }}
          recording = {this.state.selectedRecording}
          type = {this.state.type}
          downloadVideo = {this.downloadVideo}
         />} */}
         <div className="table-wrapper">
          <Table
            selectable={false}
            fixedHeader={true}
            selectedColor="black"
            height="72vh"
            className="room-recording-table"
            style={{ border: "1px solid #b8b8b8", minWidth: "900px" }}
          >
              <TableHeader displaySelectAll={false} enableSelectAll={false} adjustForCheckbox={false}>
              <TableRow
                style={{
                  border: "1px solid #b8b8b8",
                  backgroundColor: "#6B7c93",
                  color: "#fff",
                }}
              >
                <TableRowColumn colSpan={3} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.room_name" />}
                </TableRowColumn>
                <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.started_at" />}
                </TableRowColumn>
                <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.ended_at" />}
                </TableRowColumn>
                <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.duration" />}
                </TableRowColumn>
                <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.play" />}
                </TableRowColumn>
                {!checkMobile() && !isIpadOS() && <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.videoDownload" />}
                </TableRowColumn>}
                {/* <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.transcription" />}
                </TableRowColumn> */}
                {/* {!checkMobile() && !isIpadOS() && <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.transcriptionDownload" />}
                </TableRowColumn>} */}
                <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                  {<FormattedMessage id="roomRecordings.delete" />}
                </TableRowColumn>
              </TableRow>
              </TableHeader>

              <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
              {this.props.isFetchingList ||
                (this.props.roomRecordings.length === 0 && (
                  <TableRow
                    selected={false}
                    className="light-row"
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                    }}
                  >
                    <TableRowColumn colSpan={!checkMobile() && !isIpadOS() ? 19 : 15 } style={tdStyle}>
                      {this.props.isFetchingList ? (
                        <FormattedMessage id="roomRecordings.fetchingRecordings" />
                      ) : (
                        <FormattedMessage id="roomRecordings.noRecordings" />
                      )}
                    </TableRowColumn>
                  </TableRow>
                ))}

              {this.props.roomRecordings.map((recording, index) => {
                const transcriptions = JSON.parse(recording.google_stt);

                return (
                  <TableRow
                    key={index}
                    selected={false}
                    className={index % 2 == 0 ? "dark-row" : "light-row"}
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                    }}
                  >
                    <TableRowColumn colSpan={3} style={tdStyle}>
                      {recording.channel_id.split(".")[1]} <br />(
                      {recording.is_webinar ? (
                        <FormattedMessage id="activityLogs.webinar" />
                      ) : (
                        <FormattedMessage id="activityLogs.conference" />
                      )}
                      )
                    </TableRowColumn>

                    <TableRowColumn colSpan={2} style={tdStyle}>
                      {moment
                        .unix(recording.recording_started_at)
                        .format("YYYY-MM-DD HH:mm:ss")}
                    </TableRowColumn>

                    <TableRowColumn colSpan={2} style={tdStyle}>
                      {moment
                        .unix(recording.recording_ended_at)
                        .format("YYYY-MM-DD HH:mm:ss")}
                    </TableRowColumn>

                    <TableRowColumn colSpan={2} style={tdStyle}>
                      {this.durationFormat(
                        recording.recording_ended_at,
                        recording.recording_started_at
                      )}
                    </TableRowColumn>

                    <TableRowColumn colSpan={2} style={tdStyle}>
                      <AvPlayCircleFilled onClick={() => window.open(recording.s3_url, "_blank")} style={iconStyle} />
                    </TableRowColumn>

                    {!checkMobile() && !isIpadOS() && <TableRowColumn colSpan={2} style={tdStyle}>
                      <ActionGetApp
                        onClick={() => this.downloadVideo(recording.s3_url)}
                        style={iconStyle}
                      />
                      </TableRowColumn>}

                    {/* <TableRowColumn colSpan={2} style={tdStyle}>
                      {transcriptions && transcriptions.length > 0 ? (
                        <EditorInsertDriveFile
                          onClick={() => this.viewTranscriptions(recording)}
                          style={iconStyle}
                        />
                      ) : (
                        "-"
                      )}
                    </TableRowColumn> */}

                    {/* {!checkMobile() && !isIpadOS() && <TableRowColumn colSpan={2} style={tdStyle}>
                      {transcriptions && transcriptions.length > 0 ? (
                        <ActionGetApp
                          onClick={() => this.downloadTranscription(recording)}
                          style={iconStyle}
                        />
                      ) : (
                        "-"
                      )}
                    </TableRowColumn>} */}

                    <TableRowColumn colSpan={2} style={tdStyle}>
                      <Delete
                        key={recording.id}
                        onClick={(e) => this.handleDelete(e, recording.id)}
                        style={iconStyle}
                      />
                    </TableRowColumn>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

export default injectIntl(RoomRecordingsTable);



// WEBPACK FOOTER //
// src/components/RoomRecordingsTable/Table.js